/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiDowJonesListState,
    InternalApiDowJonesListStateFromJSON,
    InternalApiDowJonesListStateToJSON,
} from '../models';

/**
 * 
 */
export class DowJonesStateApi extends runtime.BaseAPI {

    /**
     * Gives metadata if Dow Jones state is OK.
     */
    async findStateRaw(initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiDowJonesListState>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/dow-jones/state`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiDowJonesListStateFromJSON(jsonValue));
    }

    /**
     * Gives metadata if Dow Jones state is OK.
     */
    async findState(initOverrides?: RequestInit): Promise<InternalApiDowJonesListState> {
        const response = await this.findStateRaw(initOverrides);
        return await response.value();
    }

}
